import { createTheme } from '@mui/material'
import { ukUA } from '@mui/material/locale'
import { ukUA as coreUkUA } from '@mui/material/locale'

export const theme = createTheme(
	{
		colorSchemes: {
			dark: {
				palette: {
					background: {
						default: '#0F0F0F',
						paper: '#1A1A1A',
					}
				}
			},
			light: {
				palette: {
					background: {
						default: '#efefef',
						paper: '#ffffff',
					}
				}
			}
		},
		cssVariables: {
			colorSchemeSelector: 'class',
		},
		components: {
			MuiButton: {
				styleOverrides: {
					root: {
						textTransform: 'none',
					},
				},
			},
			MuiChip: {
				defaultProps: {
					color: 'primary',
				}
			},
			MuiIcon: {
				defaultProps: {
					color: 'primary',
				}
			},
			MuiListItemIcon: {
				defaultProps: {
					color: 'primary',
				}
			},
			MuiLink: {
				defaultProps: {
					sx: {
						cursor: 'pointer',
					}
				}
			}
		},
	},
	ukUA,
	coreUkUA,
)
